
const addMapLayer = (context, layer) => {
    context.commit('SET_MAP_LAYER', layer);
};

const setVirtualStationLatLon = (context, vws) => {
    context.commit('SET_VIRTUAL_STATION', vws);
};

const setWfsLayer = (context, layer) => {
    context.commit('SET_WFS_STATION', layer);
};

const setMapType = (context, type) => {
    context.commit('SET_MAP_TYPE', type)
};

export default {
    addMapLayer,
    setVirtualStationLatLon,
    setWfsLayer,
    setMapType,
};